import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12" role="contentinfo">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4" id="contact-heading">Contact</h3>
            <ul className="space-y-2" aria-labelledby="contact-heading">
              <li>
                <a 
                  href="mailto:contact@novster.fr" 
                  className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                  aria-label="Envoyer un email à contact@novster.fr"
                >
                  <Mail className="w-4 h-4" />
                  contact@novster.fr
                </a>
              </li>
              <li>
                <a 
                  href="tel:+33612345678" 
                  className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  +33 6 12 34 56 78
                </a>
              </li>
              <li>
                <div className="flex items-center gap-2 text-gray-400">
                  <MapPin className="w-4 h-4" />
                  Paris, France
                </div>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/sales" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Ventes & Prospection
                </Link>
              </li>
              <li>
                <Link 
                  to="/marketing" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Marketing & Contenu
                </Link>
              </li>
              <li>
                <Link 
                  to="/bi" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Business Intelligence
                </Link>
              </li>
            </ul>
          </div>

          {/* Ressources */}
          <div>
            <h3 className="font-bold text-lg mb-4">Ressources</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/blog" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/tools" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Outils IA
                </Link>
              </li>
              <li>
                <Link 
                  to="/quiz" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Quiz IA
                </Link>
              </li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h3 className="font-bold text-lg mb-4">Informations légales</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/mentions-legales" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link 
                  to="/cgv" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  CGV
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Novster. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}